import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { logout } from '../redux/actions';
import { removeToken } from '../auth';

export default function useAuthAction() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const loggedIn = useSelector((state) => state.user.loggedIn);

    return useCallback(() => {
        if (loggedIn) {
            removeToken();
            dispatch(logout());
        }
        navigate('/login');
    }, [loggedIn, dispatch, navigate]);
}
